import { Patient } from "@repo/domain";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/")({
  component: DashboardComponent,
});

function DashboardComponent() {
  const { medplum, profile } = Route.useRouteContext();

  const name = profile?.resourceType === "Patient" ? Patient.displayName(profile.name) : profile?.name?.[0];
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center p-8">
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-extrabold tracking-tight text-balance mb-4">Provider Dashboard</h1>
        <p className="text-muted-foreground">
          Welcome, {name?.given?.join(" ")} {name?.family}
        </p>
        <div>Current User: {profile?.telecom?.[0]?.value}</div>
        <div className="space-y-4">Current Project: {medplum.getProject()?.name}</div>
      </div>
    </div>
  );
}
